import React from "react";
import Loader from './Loader';
import Navbar from "./Navbar";
import Header from './Header';
import Container from './container/Container';
import Footer from './Footer';
import useFetchSchoolData from "../hooks/useFetchSchoolData";
import useSidebarToggle from "../hooks/useSidebarToggle";

const Dashboard = () => {
    useFetchSchoolData();
    useSidebarToggle();
   
    return (
        <div>
            <Loader />
            <Navbar />
            <Header />
            <Container />
            <Footer />
        </div>
    );
};

export default Dashboard;
